const amountFormatter = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

export const formatCurrency = (amount: number, currency: "AED" = "AED") => {
  if (currency !== "AED") throw new Error("UNSUPPORTED_CURRENCY");
  return `AED ${amountFormatter.format(amount)}`;
};
